import axiosInstance from "shared/axios";

export const getSampleFileAPI = (module, reason) => {
    let url = `/api/v1/bulk-upload/sample-file?module=${module}&reason=${reason}`;
    return axiosInstance.get(url);
};